import React from "react";
import PropTypes from "prop-types";
import theme from "../../../themes/themes";
import { Button, Typography, CircularProgress, Box } from "@mui/material";

export default function PrimaryButton({
  id,
  label,
  onClick,
  disabled,
  isLoading,
  size,
  width,
  startIcon
}) {
  const StartIcon = startIcon;

  return (
    <Button
      id={id}
      onClick={onClick}
      disabled={disabled}
      sx={{
        width: width,
        minWidth: "32px",
        textTransform: "none",
        borderRadius: "4px",
        color: "white_opacity.100",
        backgroundColor: "primary.60",
        border: `1px solid ${theme.palette["primary"]["60"]}`,
        padding: size === "small" ? "2px 4px" : "4px 6px",
        "&:hover": {
          backgroundColor: "white_opacity.100",
          border: `1px solid ${theme.palette["primary"]["60"]}`,
          color: "primary.60"
        },
        "&:focus": {
          backgroundColor: "white_opacity.100",
          border: `1px solid ${theme.palette["primary"]["60"]}`,
          color: "primary.60"
        },
        "&:active": {
          backgroundColor: "primary.70",
          border: `1px solid ${theme.palette["primary"]["70"]}`,
          color: "white_opacity.100",
        },
        "&:disabled": {
          backgroundColor: "primary.10",
          border: `1px solid ${theme.palette["primary"]["10"]}`,
          color: "primary.30"
        },
      }}
    >
      {isLoading ? (
        <CircularProgress sx={{ color: disabled ? "primary.60" : "white_opacity.100" }} size={size === "small" ? 16 : 20} />
      ) : (
        <Box sx={{ display: "inline-flex", alignItems: "center" }}>
          {startIcon && <StartIcon sx={{ fontSize: size === "small" ? "16px" : "20px", ...label && { marginRight: "4px" } }} />}
          <Typography
            variant={size === "small" ? "button2" : "button1"}
          >
            {label}
          </Typography>
        </Box>
      )}
    </Button>
  );
}

PrimaryButton.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  size: PropTypes.string,
  width: PropTypes.string,
  startIcon: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func
  ])
};